import { combineReducers } from 'redux';

import { reducer as auth } from '../auth';
import { reducer as connection } from '../connection';
import { reducer as newsletter } from '../newsletter';
import { reducer as newsletters } from '../newsletters';
import { reducer as targets } from '../targets';
import { reducer as token } from '../token';
import { reducer as user } from '../user';

const reducers = {
  auth,
  user,
  connection,
  newsletter,
  newsletters,
  targets,
  token,
};

export default combineReducers(reducers);
